import clsx from 'clsx'
import type { PropsWithChildren, ReactElement } from 'react'
import { box, paperContentPadding } from './Paper.css'

export const Paper = ({
  children,
  contentPadding = true,
  className
}: PropsWithChildren<{
  className?: string
  contentPadding?: boolean
}>): ReactElement => (
  <div className={clsx(box, contentPadding && paperContentPadding, className)}>
    {children}
  </div>
)
